import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCandidateHires } from "../Action/api";

// Async thunk — only called when we actually need fresh data
export const fetchCandidates = createAsyncThunk(
  "candidates/fetchCandidates",
  async (monthYear, { rejectWithValue }) => {
    const result = await getCandidateHires(monthYear);
    if (result.success) {
      return { data: result.data, count: result.count, monthYear };
    }
    return rejectWithValue(result.message || "Failed to load candidates");
  }
);

const candidatesSlice = createSlice({
  name: "candidates",
  initialState: {
    // cache: { "Feb-2026": { data: [], count: 0 }, ... }
    cache: {},
    loading: false,
    error: null,
    // which monthYear is currently "active" in the dashboard view
    activeMonthYear: null,
  },
  reducers: {
    setActiveMonth(state, action) {
      state.activeMonthYear = action.payload;
    },
    // Allow the detail page to optimistically update a single candidate's status
    updateCandidateInStore(state, action) {
      const { monthYear, timeStamp, status } = action.payload;
      const cached = state.cache[monthYear];
      if (!cached) return;
      const idx = cached.data.findIndex((c) => c.timeStamp === timeStamp);
      if (idx !== -1) {
        cached.data[idx] = { ...cached.data[idx], status };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidates.fulfilled, (state, action) => {
        const { data, count, monthYear } = action.payload;
        state.cache[monthYear] = { data, count };
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchCandidates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unknown error";
      });
  },
});

export const { setActiveMonth, updateCandidateInStore } = candidatesSlice.actions;
export default candidatesSlice.reducer;
